import QuickMovementForm from "./QuickMovementForm";
export default function SaleForm() { return <QuickMovementForm type="sale" />; }
